import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Solutions = () => {
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  return (
    <section className="solutions" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>Enterprise Solutions</h2>
          <p>Comprehensive technology solutions designed for enterprise scale and complexity</p>
        </motion.div>
        
        <div className="solutions-showcase">
          <div className="solution-highlight">
            <h3>Digital Workplace Transformation</h3>
            <p>Modernize your workforce with intelligent collaboration tools and automation</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;